export const FETCH_COURSE_TYPE_LIST_END = "setCourseTypeList";
export const FETCH_COURSE_TYPE_START = "setLoadingCourseType";
export const SET_COURSE_TYPE = "setCourseType";
export const TOGGLE_COURSE_TYPE_EDIT_STATE = "TOGGLE_COURSE_TYPE_EDIT_STATE";
export const LOAD_COURSE_TYPE_TO_EDIT = "LOAD_COURSE_TYPE_TO_EDIT";
export const TOGGLE_EDIT_COURSE_TYPE_DIALOG = "TOGGLE_EDIT_COURSE_TYPE_DIALOG";
export const RESET_DEFAULT_NEW_COURSE_TYPE = "RESET_DEFAULT_NEW_COURSE_TYPE";
export const RESET_DEFAULT_NEW_COURSE_TYPE_LIST =
    "RESET_DEFAULT_NEW_COURSE_TYPE_LIST";
export const TOGGLE_NEW_COURSE_TYPE_DIALOG = "TOGGLE_NEW_COURSE_TYPE_DIALOG";
export const UPDATE_COURSE_TYPE_FIELD = "UPDATE_COURSE_TYPE_FIELD";
export const RESET_DEFAULT_COURSE_TYPE_TO_EDIT =
    "RESET_DEFAULT_COURSE_TYPE_TO_EDIT";
export const UPDATE_ADD_COURSE_TYPE_FIELD = "UPDATE_ADD_COURSE_TYPE_FIELD";
